/*
	import { eraseVirtualMeeting } from '@/services/BoardMeetings/VirtualMeeting/Delete';

  const { successful } = await eraseVirtualMeeting ({
    virtualMeetingID
  });
*/

/*

*/

import kms from '@/services/kms'
import { notifyError } from '@/services/notify'

export async function eraseVirtualMeeting({ virtualMeetingID }) {
  let exception = ''

  try {
    const result = await kms.delete(`/BoardMeetings/VirtualMeeting/${virtualMeetingID}`)

    return {
      successful: true,
      message: 'The virtual meeting was deleted successfully.',
      exception: null,
      phoneMeeting: result
    }
  } catch (_exception) {
    exception = _exception
  }

  let message = 'A problem occurred and the virtual meeting could not be deleted.'
  notifyError(message)

  return {
    successful: false,
    message,
    exception,
    phoneMeeting: null
  }
}
